export default __webpack_public_path__ + "d3044f7016065e78edcf6060953019d1.png";